import moment from "moment";

export const AI_AGENT_NOTE_ACTOR = "Florizel AI Agent";

const getAgentIntentText = (record) => {
  const agentIntent =
    record?.intakeQuestions?.agentIntent ||
    record?.intakequestions?.agentIntent;

  if (agentIntent == null) return "";
  if (typeof agentIntent === "string") return agentIntent.trim();
  if (typeof agentIntent === "object") {
    const objectValue =
      agentIntent.display ||
      agentIntent.value ||
      JSON.stringify(agentIntent);

    return objectValue ? String(objectValue).trim() : "";
  }

  return String(agentIntent).trim();
};

export const getNotesWithAgentIntent = (record) => {
  const notes = Array.isArray(record?.notes) ? record.notes : [];
  const agentIntentText = getAgentIntentText(record);

  if (!agentIntentText) return notes;

  return [
    ...notes,
    {
      actor: {
        display: AI_AGENT_NOTE_ACTOR,
        type: "AI",
      },
      isAgentIntent: true,
      note: agentIntentText,
      updatedAt: record?.updatedAt || record?.createdAt,
    },
  ];
};

export const formatNoteTimestamp = (timestamp) => {
  if (!timestamp) return "-";

  return moment(timestamp).format("DD-MMM-YY HH:mm");
};
